import React from 'react';
import PropTypes from 'prop-types';
import { MixpanelEventName, Modes } from '../Constants';
import Classes from '../Classes';
import MixPanelHelper from '../MixPanelHelper';

const splitter = ',, ';

const setupCurrentLevel = (currentObject, index, currentLevelsOnly, lastLevel) => {
  let ppsText = '';
  if (Array.isArray(currentObject)) {
    if (index !== 0 && currentObject.length > 0) {
      ppsText += splitter;
    }
    const newArray = [];
    currentObject.forEach((element) => {
      if (element.indexOf('>') >= 0) {
        const [, currentItem] = element.split('>');
        newArray.push(currentItem);
      } else {
        newArray.push(element);
      }
    });
    ppsText += newArray.join(splitter);
  } else {
    if (index !== 0) {
      ppsText += splitter;
    }
    ppsText += JSON.stringify(currentLevelsOnly[lastLevel]);
  }
  return ppsText;
};

const setupPPSAnswers = (answer, index) => {
  let ppsText = '';
  if (answer.length === 2) {
    const currentLevels = answer[1];
    if (Object.prototype.hasOwnProperty.call(currentLevels, 'sortOrder')) {
      const currentLevelsOnly = JSON.parse(JSON.stringify(currentLevels));
      delete currentLevelsOnly.sortOrder;
      const lastLevel = Object.keys(currentLevelsOnly).pop();
      const currentObject = currentLevelsOnly[lastLevel];
      ppsText += setupCurrentLevel(currentObject, index, currentLevelsOnly, lastLevel);
    }
  }
  return ppsText;
};

const SetupPPSListData = (participantPpsList) => {
  if (participantPpsList) {
    let ppsText = '';
    let index = 0;

    Object.entries(participantPpsList).forEach((answer) => {
      ppsText += setupPPSAnswers(answer, index);
      index += 1;
    });

    ppsText = ppsText.replaceAll(splitter, ',');
    return ppsText.toUpperCase();
  }

  return null;
};

const handleClick = (eventName, participantId, interactedElement) => {
  MixPanelHelper.trackInteractedEvents(eventName, participantId, interactedElement);
};

const PpsList = ({
  participantPpsList, dtmTag, dataDtmAttributes = '', context, profileUrl, participantId
}) => {
  const ppsFilterText = SetupPPSListData(participantPpsList);

  return ((ppsFilterText && context.mode !== Modes.private) ? (
    <div
      className={Classes.homePage.participantItem.participantPpsListWrapper}
      data-dtm={dtmTag}
      data-dtm-attributes={dataDtmAttributes}
      data-testid="ppsList"
    >
      <a
        href={profileUrl}
        onClick={() => handleClick(MixpanelEventName.ParticipantInteracted, participantId, 'Pps')}
      >
        {ppsFilterText}
      </a>
    </div>
  ) : null);
};

PpsList.propTypes = {
  participantPpsList: PropTypes.object.isRequired,
  dtmTag: PropTypes.string.isRequired,
  dataDtmAttributes: PropTypes.string,
  context: PropTypes.object.isRequired,
  profileUrl: PropTypes.string.isRequired,
  participantId: PropTypes.string.isRequired
};

export default PpsList;
